import type {MessageDescriptor} from 'react-intl';
import type {Locale} from 'src/types';

export class IntlError extends Error {
  constructor(message: string) {
    super(`[@sail/intl] ${message}`);
  }
}

class ReactIntlBaseError extends IntlError {
  constructor(reactIntlError: Error) {
    const message = reactIntlError.message.replace(
      /\[React Intl[^\]]*?\]\s?/,
      '',
    );

    super(message);
  }
}

class ReactIntlMessageFormatBaseError extends IntlError {
  constructor(reactIntlError: Error) {
    const message = reactIntlError.message.replace(
      /\[formatjs Error:[^\]]*?\]\s?/,
      '',
    );

    super(message);
  }
}

export class IntlMissingLocaleData extends IntlError {
  constructor(locale: Locale) {
    super(`Missing "${locale}" locale data!`);
  }
}

export class IntlFormatMessageError extends IntlError {}

// react-intl errors
export class IntlMissingTranslationError extends ReactIntlBaseError {
  descriptor?: MessageDescriptor;
  constructor(reactIntlError: Error, descriptor?: MessageDescriptor) {
    super(reactIntlError);
    this.descriptor = descriptor;
  }
}
export class IntlMessageFormatError extends ReactIntlBaseError {}
export class IntlMissingDataError extends ReactIntlBaseError {}
export class IntlInvalidConfigError extends ReactIntlBaseError {}
export class IntlMissingMessageError extends IntlError {
  constructor() {
    super('A message must be provided to format a message.');
  }
}

// intl-messageformat errors
export class IntlMessageFormatInvalidValueError extends ReactIntlMessageFormatBaseError {}
export class IntlMessageFormatMissingValueError extends ReactIntlMessageFormatBaseError {}
export class IntlMessageFormatMissingIntlAPIError extends ReactIntlMessageFormatBaseError {}

export class IntlLocaleDataError extends IntlError {
  constructor(message: string) {
    super(
      `${message} Make sure to initialize \`@sail/intl\` with the correct locale data.`,
    );
  }
}

export class IntlUnsupportedTimeZoneError extends IntlError {
  constructor(timeZone: string) {
    super(
      `Unsupported time zone \`${timeZone}\`. See the full list of supported time zones at https://github.com/moment/moment-timezone/blob/0.5.30/data/packed/2014a.json`,
    );
  }
}

export class IntlUnknownTimeZoneError extends IntlError {}
